import config from '@/config'
import axios from "axios";

const Client = {
    getFilters() {
        let path = `${config.camunda.api.path}/filter`;
        return this.get(path);
    },
    getFilterTasks(filterId, query) {
        let path = `${config.camunda.api.path}/filter/${filterId}/list`;
        return this.get(path, {
            params: query,
            'headers': {
                'Accept': 'application/hal+json, application/json'
            }
        });
    },
    getFilterTasksCount(filterId) {
        let path = `${config.camunda.api.path}/filter/${filterId}/count`;
        return this.get(path);
    },
    claimTask(taskId, userId) {
        let path = `${config.camunda.api.path}/task/${taskId}/claim`;
        return this.post(path, {
            userId: userId
        });
    },
    unclaimTask(taskId) {
        let path = `${config.camunda.api.path}/task/${taskId}/unclaim`;
        return this.post(path);
    },
    getTasks(filter) {
        let path = `${config.camunda.api.path}/task`;
        return this.get(path, {
            params: filter
        });
    },
    getTasksCount(filter) {
        let path = `${config.camunda.api.path}/task/count`;
        return this.get(path, {
            params: filter
        });
    },
    getTask(taskId) {
        let path = `${config.camunda.api.path}/task/${taskId}`;
        return this.get(path);
    },
    getTaskForm(taskId) {
        let path = `${config.camunda.api.path}/task/${taskId}/deployed-form`;
        return this.get(path);
    },
    getProcessDefinitionByKey(processKey) {
        let path = `${config.camunda.api.path}/process-definition/key/${processKey}`;
        return this.get(path);
    },
    getDeploymentResources(deploymentId) {
        let path = `${config.camunda.api.path}/deployment/${deploymentId}/resources`;
        return this.get(path);
    },
    getDeploymentResourceData(deploymentId, resourceId) {
        let path = `${config.camunda.api.path}/deployment/${deploymentId}/resources/${resourceId}/data`;
        return this.get(path);
    },
    startProcessInstanceId(definitionId, body = {}) {
        let path = `${config.camunda.api.path}/process-definition/key/${definitionId}/start`;
        return this.post(path, {});
    },
    findProcessInstance(query) {
        let path = `${config.camunda.api.path}/process-instance`;
        return this.post(path, query);
    },
    findProcessInstanceFromHistory(query) {
        let path = `${config.camunda.api.path}/history/process-instance`;
        return this.post(path, query);
    },
    getProcessInstance(instanceID) {
        let path = `${config.camunda.api.path}/process-instance/${instanceID}`;
        return this.get(path);
    },
    getProcessInstanceHistory(instanceID) {
        let path = `${config.camunda.api.path}/history/process-instance/${instanceID}`;
        return this.get(path);
    },
    getProcessInstanceVariables(instanceID) {
        let path = `${config.camunda.api.path}/process-instance/${instanceID}/variables?deserializeValues=false`;
        return this.get(path);
    },
    getProcessInstanceTasks(instanceID, active = 'true') {
        let path = `${config.camunda.api.path}/task?processInstanceId=${instanceID}&active=${active}&sortBy=priority&sortOrder=desc`;
        return this.get(path);
    },
    startProcessInstanceKey(definitionKey, body = {}) {
        let path = `${config.camunda.api.path}/process-definition/key/${definitionKey}/start`;
        return this.post(path, body);
    },
    getProcessStartFormKey(definitionId) {
        let path = `${config.camunda.api.path}/process-definition/${definitionId}/startForm`;
        return this.get(path);
    },
    getProcessInstanceActivityInstances(instanceID) {
        let path = `${config.camunda.api.path}/process-instance/${instanceID}/activity-instances`;
        return this.get(path);
    },
    postTaskForm(taskId, body) {
        let path = `${config.camunda.api.path}/task/${taskId}/submit-form`;
        return this.post(path, body);
    },
    postMessage(body) {
        let path = `${config.camunda.api.path}/message`;
        return this.post(path, body);
    },
    get(path, options = {}) {
        if (config.camunda.enableAuth) {
            let headers = options.headers || {};
            let token = window.RUNBUGGY_TOKEN;

            if (token) {
                headers['Authorization'] = `Bearer ${token}`;
            } else {
                headers['Authorization'] = `Basic YW5vbnltb3VzOg==`;
            }

            options.headers = headers;
        }


        return axios.get(path, options);
    },
    post(path, data, options = {}) {
        if (config.camunda.enableAuth) {
            let headers = options.headers || {};
            let token = window.RUNBUGGY_TOKEN;

            if (token) {
                headers['Authorization'] = `Bearer ${token}`;
            } else {
                headers['Authorization'] = `Basic YW5vbnltb3VzOg==`;
            }

            options.headers = headers;
        }

        return axios.post(path, data, options);
    }
};

/*
{
  "variables": {
    "bulkOrdersFile": {
      "value": "UEsDBBQABgAIAAAAIQBBN4LPbgEAAAQFAAATAAgCW0NvbnRlbnRfVHlwZXNdLnhtbCCiB...",
      "type": "File",
      "valueInfo": {
        "filename": "Transport to Recon Centers 3-8-19.xlsx",
        "mimeType": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
      }
    },
    "limitPerOrder": {
      "value": 12,
      "type": "Integer"
    },
    "paymentBy": {
      "value": "21",
      "type": "String"
    },
    "templateName": {
      "value": "002",
      "type": "String"
    }
  }
}
 */

export default Client;
